import React, { useContext } from "react";
import "./SidebarLeft.css";
import SidebarLink from "./SidebarLink";
import { UserContext } from "../context/UserContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@material-ui/core/Button";
import { faDog } from "@fortawesome/free-solid-svg-icons";

function SidebarLeft() {
  const { user, setUser } = useContext(UserContext);
  function logout() {
    localStorage.removeItem("userData");
    setUser(null);
  }
  return (
    <div className="sidebarleft">
      <div className="title-barker">
        <FontAwesomeIcon icon={faDog} size="2x" />
        <h2>Barker</h2>
      </div>
      {user && <p className="user">Logged in: {user.username}</p>}
      <SidebarLink route="/" text="Home" />
      {user === null && <SidebarLink route="/signup" text="Signup" />}
      {user === null && <SidebarLink route="/login" text="Login" />}

      {user && (
        <Button color="secondary" className="link-item" onClick={logout}>
          <p>logout</p>
        </Button>
      )}
    </div>
  );
}

export default SidebarLeft;
